export const CUSTOM_TOUR_EVENTS = {
  PROFILE_CLICK: "PROFILE_CLICK",
  INFO_CLICK: "INFO_CLICK",
  IFRAME_CLICK: "IFRAME_CLICK",
  CLOSE_MODALS: "CLOSE_MODALS",
  IMAGE_GALLERY: "IMAGE_GALLERY",
  CUSTOM_SLIDE: "CUSTOM_SLIDE",
  CLOSE_VIDEO: "CLOSE_VIDEO",
  START_VIDEO: "START_VIDEO",
  SCENE_CHANGE: "SCENE_CHANGE",
}

export const SOCKET_EVENTS = {
  MESSAGE_RECEIVED: 'MESSAGE_RECEIVED',
  GLOBAL_MESSAGE_SENT: 'GLOBAL_MESSAGE_SENT',
  MESSAGE_SEND: 'MESSAGE_SEND',
  DATA_RECEIVED: 'DATA_RECEIVED',
  USER_DATA_CHANGED: 'USER_DATA_CHANGED',
  SOCKET_READY: 'SOCKET_READY',
  ADD_ONE_ON_ONE_CHAT: 'ADD_ONE_ON_ONE_CHAT',
  ONE_ONE_ONE_MESSAGE_RECEIVED: 'ONE_ONE_ONE_MESSAGE_RECEIVED',
  ONE_ONE_ONE_MESSAGE_SENT: 'ONE_ONE_ONE_MESSAGE_SENT',
  TOUR_MESSAGE_SENT: 'TOUR_MESSAGE_SENT',
  TOUR_MESSAGE_RECEIVED: 'TOUR_MESSAGE_RECEIVED',
  OFFLINE_MESSAGE_SENT: 'OFFLINE_MESSAGE_SENT',
  LOCAL_MESSAGE_RECEIVED: 'LOCAL_MESSAGE_RECEIVED',
  USER_ONE_ON_ONE_SENT: 'USER_ONE_ON_ONE_SENT',
  USER_JOINED_SCENE: 'USER_JOINED_SCENE',
  USER_LEFT_SCENE: 'USER_LEFT_SCENE',
  USER_DISCONNECTED: 'USER_DISCONNECTED',
  APTIS_WEB_RTC_DATA: 'APTIS_WEB_RTC_DATA',
  APTIS_WEBRTC_SIGNAL: 'APTIS_WEBRTC_SIGNAL',
  REQUEST_ACCEPTED: 'REQUEST_ACCEPTED',
  REQUEST_RECEIVED: 'REQUEST_RECEIVED',
  SOCKET_CONNECT_SUCCESS: 'SOCKET_CONNECT_SUCCESS',
  SOCKET_CONNECT_ERROR: 'SOCKET_CONNECT_ERROR',
  FEATURE_AVAILABILITY_ERROR: 'FEATURE_AVAILABILITY_ERROR',
  CHAT_HISTORY_LOADED: 'CHAT_HISTORY_LOADED',
  GAMING_DATA: 'GAMING_DATA',
  FRIENDS_LIST_LOADED: 'FRIENDS_LIST_LOADED',
  ONLINE_FRIENDS_LOADED: 'ONLINE_FRIENDS_LOADED',
  DISCONNECT: 'DISCONNECT',
  FREEZE_SESSION: 'FREEZE_SESSION',
  RESUME_SESSION: 'RESUME_SESSION',

  USER_VIDEO_STATE_CHANGED: 'USER_VIDEO_STATE_CHANGED',
  USER_CHANGED_SCREEN_SHARE_SEAT: 'USER_CHANGED_SCREEN_SHARE_SEAT',

  INIT_USERS: 'INIT_USERS',
  TOUR_USER_CHANGED_SCREEN_SHARE_SEAT: 'TOUR_USER_CHANGED_SCREEN_SHARE_SEAT',
  USER_MICROPHONE_STATE_CHANGED: 'USER_MICROPHONE_STATE_CHANGED',
  CHESS_MESSAGE_RECEIVED: 'CHESS_MESSAGE_RECEIVED',
};

export const EDITOR_SOCKET_EVENTS = {
  JOIN_EDITOR: 'join_editor',
  REQUEST_TAKEOVER: 'request_takeover',
  TAKEOVER_RESPONSE: 'takeover_response',
  TAKEOVER_REQUEST: 'takeover_request',
  TAKEOVER_RESPONSE_ACCEPTED: 'takeover_response_accepted',
  TAKEOVER_RESPONSE_REJECTED: 'takeover_response_rejected',
  TAKEOVER_RESPONSE_CANCELLED: 'takeover_response_cancelled',
  TAKEOVER_RESPONSE_PENDING: 'takeover_response_pending',
  CONFIRM_TAKEOVER: 'confirm_takeover',
  CONFIRM_TAKEOVER_RESPONSE: 'confirm_takeover_response',
  LOCK_EDITOR: 'lock_editor',
  LOCK_STATUS: 'lock_status',
  EDITOR_STATUS: 'editor_status',
  EDITOR_STATUS_OPEN: 'open',
  EDITOR_STATUS_LOCKED: 'locked',
  EDITOR_STATUS_OCCUPIED: 'occupied',
  MODAL_TAKEOVER_REQUEST: 'MODAL_TAKEOVER_REQUEST',
  MODAL_CONFIRM_TAKEOVER_REQUEST: 'MODAL_CONFIRM_TAKEOVER_REQUEST',
  MODAL_CONFIRM_TAKEOVER_REQUEST_PENDING: 'MODAL_CONFIRM_TAKEOVER_REQUEST_PENDING',
}
